module.exports = __webpack_public_path__ + "img/Health.1d74ef4d.svg";